import axios from "axios"
import {
  getRefreshToken,
  getAccessToken,
  setTokensToLocalStorage,
  removeUserFromLocalStorage,
  removeTokensFromLocalStorage,
} from "../utils"
import { DateTime } from "luxon"
import { getAccessTokenViaRefreshToken } from "../api/auth"

const apiBaseURL = process.env.REACT_APP_BASE_URL
export const authorizedInstance = axios.create({
  baseURL: apiBaseURL,
})

export const refreshTokenExpired = () => {
  const refreshToken = getRefreshToken()
  if (!refreshToken?.expiresIn) {
    return true
  }
  try {
    const tokenExpiryTime = DateTime.fromSeconds(refreshToken.expiresIn).toUTC()
    const currentTime = DateTime.utc()

    return tokenExpiryTime < currentTime
  } catch (error) {
    console.error("Error parsing token expiry time:", error)
    return true
  }
}

const handleUnauthorizedCase = async (originalRequest) => {
  const refreshToken = getRefreshToken()
  const response = await getAccessTokenViaRefreshToken(refreshToken?.token)
  setTokensToLocalStorage(response.accessToken, refreshToken)
  originalRequest.headers["Authorization"] = `Bearer ${refreshToken.token}`
  return authorizedInstance(originalRequest)
}

authorizedInstance.interceptors.request.use(
  (config) => {
    const accessToken = getAccessToken()
    if (accessToken?.token) {
      config.headers["Authorization"] = `Bearer ${accessToken?.token}`
      return config
    } else return Promise.reject(new Error("Authorization token required"))
  },
  (error) => Promise.reject(error),
  { synchronous: true }
)

authorizedInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalRequest = error.config
    if (refreshTokenExpired()) {
      removeTokensFromLocalStorage()
      removeUserFromLocalStorage()
    } else if (error.response?.status === 401) {
      return handleUnauthorizedCase(originalRequest)
    } else return Promise.reject(error)
  }
)

export const publicInstance = axios.create({
  baseURL: apiBaseURL,
})
